(() => {
  const IS_LOCALHOST =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const LOCAL_TEST_EMAIL = "ryanblount98@gmail.com";

  let currentEntriesData = null;
  let dailyClaimState = null;
  let dailyCountdownTimer = null;
  let dailyClaimInFlight = false;

  let dailySpinState = null;
  let dailySpinCountdownTimer = null;
  let dailySpinInFlight = false;
  let dailySpinRotation = 0;
  let dailySpinHistory = [];
  let dailySpinBonusTimer = null;

  let lastFocusedElement = null;

  function getRoot() {
    return document.querySelector(".uc-my-entries-page");
  }

  function getBox() {
    return document.getElementById("ucEntriesBox");
  }

  function setBox(html) {
    const box = getBox();

    if (box) {
      box.innerHTML = html;
    }
  }

  function fmt(n) {
    return Number(n || 0).toLocaleString("en-US");
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getEntryGoal() {
    const root = getRoot();

    const goal = Number(
      root?.dataset?.entryGoal || 10000000
    );

    if (
      !Number.isFinite(goal) ||
      goal <= 0
    ) {
      return 10000000;
    }

    return goal;
  }

  function isDailyEnabled() {
    const root = getRoot();

    return (
      root?.dataset?.dailyEnabled === "true" &&
      !!document.getElementById("ucDailyClaimCard")
    );
  }

  function isDailySpinEnabled() {
    const root = getRoot();

    return (
      root?.dataset?.spinEnabled === "true" &&
      !!document.getElementById("ucDailySpinCard")
    );
  }

  function isDailyUpsellEnabled() {
    const root = getRoot();

    return (
      root?.dataset?.dailyUpsellEnabled === "true" &&
      !!document.getElementById("ucDailyUpsellModal")
    );
  }

  async function waitForTurnstileToken(
    timeoutMs = 120000
  ) {
    const start = Date.now();

    while (
      Date.now() - start <
      timeoutMs
    ) {
      const el =
        document.querySelector(
          '[name="cf-turnstile-response"]'
        ) ||
        document.querySelector(
          'textarea[name="cf-turnstile-response"]'
        );

      const token = String(
        el?.value || ""
      ).trim();

      if (token) {
        return token;
      }

      await new Promise(
        (resolve) =>
          setTimeout(resolve, 150)
      );
    }

    return "";
  }

  function showError(
    title,
    message,
    extra = ""
  ) {
    setBox(`
      <div class="uc-row">

        <div class="uc-error-title">
          ${escapeHtml(title)}
        </div>

        <div class="uc-muted">
          ${escapeHtml(message)}
        </div>

        ${
          extra
            ? `
              <div class="uc-muted">
                ${escapeHtml(extra)}
              </div>
            `
            : ""
        }

      </div>
    `);
  }

  function animateEntryMeter(
    fill,
    progressPercent
  ) {
    if (!fill) {
      return;
    }

    const targetPercent = Math.max(
      0,
      Math.min(
        Number(progressPercent) || 0,
        100
      )
    );

    fill.style.width =
      `${targetPercent}%`;

    fill.style.background =
      "linear-gradient(90deg, #a60055 0%, #e60073 28%, #ff1493 58%, #ff5cb8 82%, #ff8ccc 100%)";

    fill.style.boxShadow =
      "0 0 15px rgba(255,20,147,.85), " +
      "0 0 30px rgba(255,20,147,.55), " +
      "0 0 55px rgba(255,20,147,.30), " +
      "inset 0 8px 14px rgba(255,255,255,.25), " +
      "inset 0 -8px 14px rgba(119,0,57,.18)";

    if (
      typeof fill.animate === "function" &&
      targetPercent > 0
    ) {
      const animation = fill.animate(
        [
          {
            width: "0%"
          },
          {
            width:
              `${targetPercent}%`
          }
        ],
        {
          duration: 1800,
          easing:
            "cubic-bezier(0.16, 1, 0.3, 1)",
          fill: "forwards"
        }
      );

      animation.onfinish = () => {
        fill.style.width =
          `${targetPercent}%`;

        animation.cancel();
      };
    }
  }

  function showEntries(data) {
    const box = getBox();

    if (!box) {
      return;
    }

    currentEntriesData = {
      ...data,
      total_entries: Math.max(
        0,
        Number(data.total_entries || 0)
      )
    };

    const entryGoal =
      getEntryGoal();

    const totalEntries =
      currentEntriesData.total_entries;

    const rawPercent =
      entryGoal > 0
        ? (
            totalEntries /
            entryGoal
          ) * 100
        : 0;

    const progressPercent =
      Math.max(
        0,
        Math.min(
          rawPercent,
          100
        )
      );

    const displayPercent =
      rawPercent < 0.01 &&
      totalEntries > 0
        ? "<0.01"
        : rawPercent.toLocaleString(
            "en-US",
            {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
            }
          );

    box.innerHTML = `
      <div class="uc-entry-dashboard">

        <div class="uc-entry-dashboard__label">
          Your Current Entries
        </div>

        <div
          class="uc-entry-progress"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="${entryGoal}"
          aria-valuenow="${totalEntries}"
          aria-valuetext="${fmt(totalEntries)} entries"
        >

          <div
            class="uc-entry-progress__fill"
            data-entry-progress-fill
            style="
              width: 0%;
              background:
                linear-gradient(
                  90deg,
                  #a60055 0%,
                  #e60073 28%,
                  #ff1493 58%,
                  #ff5cb8 82%,
                  #ff8ccc 100%
                );
            "
          ></div>

          <div class="uc-entry-progress__value">

            <strong>
              ${fmt(totalEntries)}
            </strong>

            <span>
              Entries
            </span>

          </div>

        </div>

        <div class="uc-entry-progress__meta">

          <span class="uc-entry-progress__percent">
            ${displayPercent}% of meter
          </span>

          <span>
            Max ${fmt(entryGoal)}
          </span>

        </div>

        <div class="uc-entry-account">
          Signed in as
          <strong>
            ${escapeHtml(
              currentEntriesData.email || ""
            )}
          </strong>
        </div>

      </div>
    `;

    const fill =
      box.querySelector(
        "[data-entry-progress-fill]"
      );

    if (fill) {
      const scale =
        Math.max(
          0,
          Math.min(
            progressPercent / 100,
            1
          )
        );

      fill.style.transform =
        "scaleX(0)";

      void fill.offsetWidth;

      setTimeout(() => {
        fill.style.transform =
          `scaleX(${scale})`;
      }, 200);
    }
  }

  function addClaimedEntriesToDashboard(entries) {
    const amount = Math.max(
      0,
      Number(entries || 0)
    );

    if (
      !amount ||
      !currentEntriesData
    ) {
      return;
    }

    showEntries({
      ...currentEntriesData,
      total_entries:
        Math.max(
          0,
          Number(
            currentEntriesData.total_entries || 0
          )
        ) + amount
    });
  }

  function getDailyElements() {
    return {
      card:
        document.getElementById(
          "ucDailyClaimCard"
        ),

      amount:
        document.getElementById(
          "ucDailyEntryAmount"
        ),

      button:
        document.getElementById(
          "ucDailyClaimButton"
        ),

      status:
        document.getElementById(
          "ucDailyClaimStatus"
        )
    };
  }

  function setDailyStatus(
    message,
    className = ""
  ) {
    const { status } =
      getDailyElements();

    if (!status) {
      return;
    }

    status.textContent =
      String(message || "");

    status.classList.remove(
      "is-ready",
      "is-success",
      "is-error"
    );

    if (className) {
      status.classList.add(
        className
      );
    }
  }

  function formatCountdown(ms) {
    const totalSeconds =
      Math.max(
        0,
        Math.ceil(
          Number(ms || 0) /
          1000
        )
      );

    const hours =
      Math.floor(
        totalSeconds / 3600
      );

    const minutes =
      Math.floor(
        (
          totalSeconds % 3600
        ) / 60
      );

    const seconds =
      totalSeconds % 60;

    return [
      String(hours).padStart(2, "0"),
      String(minutes).padStart(2, "0"),
      String(seconds).padStart(2, "0")
    ].join(":");
  }

  function clearDailyCountdown() {
    if (dailyCountdownTimer) {
      clearInterval(
        dailyCountdownTimer
      );

      dailyCountdownTimer = null;
    }
  }

  function updateDailyCountdown() {
    if (
      !dailyClaimState ||
      dailyClaimState.eligible
    ) {
      return;
    }

    const nextClaimAt = Number(
      dailyClaimState.next_claim_at || 0
    );

    const remaining =
      Math.max(
        0,
        nextClaimAt - Date.now()
      );

    if (remaining <= 0) {
      clearDailyCountdown();

      dailyClaimState = {
        ...dailyClaimState,
        eligible: true,
        milliseconds_remaining: 0
      };

      renderDailyClaimState();
      return;
    }

    setDailyStatus(
      `Next claim available in ${formatCountdown(remaining)}`,
      "is-success"
    );
  }

  function startDailyCountdown() {
    clearDailyCountdown();

    updateDailyCountdown();

    if (
      !dailyClaimState ||
      dailyClaimState.eligible
    ) {
      return;
    }

    dailyCountdownTimer =
      setInterval(
        updateDailyCountdown,
        1000
      );
  }

  function renderDailyClaimState() {
    const {
      amount,
      button
    } = getDailyElements();

    if (
      !amount ||
      !button ||
      !dailyClaimState
    ) {
      return;
    }

    const entries =
      Math.max(
        0,
        Number(
          dailyClaimState.entries || 0
        )
      );

    amount.textContent =
      `+${fmt(entries)} Entries`;

    if (dailyClaimInFlight) {
      button.disabled = true;
      button.textContent =
        "Claiming...";

      setDailyStatus(
        "Adding your free entries..."
      );

      return;
    }

    if (dailyClaimState.eligible) {
      clearDailyCountdown();

      button.disabled = false;
      button.textContent =
        `Claim ${fmt(entries)} Free Entries`;

      setDailyStatus(
        "Your daily bonus is ready.",
        "is-ready"
      );

      return;
    }

    button.disabled = true;
    button.textContent =
      "Entries Claimed";

    startDailyCountdown();
  }

  async function loadDailyStatus() {
    if (!isDailyEnabled()) {
      return;
    }

    const { button } =
      getDailyElements();

    if (button) {
      button.disabled = true;
      button.textContent =
        "Checking...";
    }

    if (
      !IS_LOCALHOST &&
      !window.UC_IS_LOGGED_IN
    ) {
      setDailyStatus(
        "Sign in to claim your daily entries.",
        "is-error"
      );

      return;
    }

    if (
      !IS_LOCALHOST &&
      window.UC_IS_CHARGEBACK
    ) {
      return;
    }

    if (IS_LOCALHOST) {
      if (button) {
        button.disabled = true;
        button.textContent =
          "Unavailable Locally";
      }

      setDailyStatus(
        "Daily claims require the signed Shopify storefront."
      );

      return;
    }

    try {
      const res = await fetch(
        "/apps/referrals?action=daily-status",
        {
          method: "GET",
          credentials: "same-origin",
          headers: {
            Accept:
              "application/json"
          }
        }
      );

      const data =
        await res
          .json()
          .catch(() => null);

      if (
        !res.ok ||
        data?.success !== true ||
        !data?.daily_claim
      ) {
        throw new Error(
          data?.error ||
          "Unable to load daily claim status."
        );
      }

      dailyClaimState = {
        ...data.daily_claim,
        entries:
          Math.max(
            0,
            Number(
              data.daily_claim.entries || 0
            )
          )
      };

      renderDailyClaimState();

    } catch (error) {
      console.error(
        "[UC DAILY ENTRIES] status failed:",
        error
      );

      if (button) {
        button.disabled = true;
        button.textContent =
          "Unavailable";
      }

      setDailyStatus(
        "Unable to check your daily entries right now.",
        "is-error"
      );
    }
  }

  async function claimDailyEntries() {
    if (
      dailyClaimInFlight ||
      !dailyClaimState?.eligible
    ) {
      return;
    }

    dailyClaimInFlight = true;
    renderDailyClaimState();

    try {
      const res = await fetch(
        "/apps/referrals?action=daily-claim",
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            Accept:
              "application/json",
            "Content-Type":
              "application/json"
          },
          body:
            JSON.stringify({})
        }
      );

      const data =
        await res
          .json()
          .catch(() => null);

      if (
        res.status === 409 &&
        data?.daily_claim
      ) {
        dailyClaimState = {
          ...data.daily_claim,
          entries:
            Math.max(
              0,
              Number(
                data.daily_claim.entries ||
                dailyClaimState?.entries ||
                0
              )
            )
        };

        dailyClaimInFlight = false;
        renderDailyClaimState();
        return;
      }

      if (
        !res.ok ||
        data?.success !== true ||
        !data?.claim
      ) {
        throw new Error(
          data?.error ||
          "Unable to claim daily entries."
        );
      }

      const claimedEntries =
        Math.max(
          0,
          Number(
            data.claim.entries ||
            dailyClaimState?.entries ||
            0
          )
        );

      const previousTotalClaims =
        Math.max(
          0,
          Number(
            dailyClaimState?.total_claims || 0
          )
        );

      dailyClaimState = {
        entries:
          claimedEntries,

        claim_hours:
          Number(
            data.claim.claim_hours ||
            dailyClaimState?.claim_hours ||
            24
          ),

        eligible:
          false,

        last_claimed_at:
          Number(
            data.claim.claimed_at ||
            Date.now()
          ),

        next_claim_at:
          Number(
            data.claim.next_claim_at || 0
          ),

        milliseconds_remaining:
          Math.max(
            0,
            Number(
              data.claim.next_claim_at || 0
            ) - Date.now()
          ),

        total_claims:
          previousTotalClaims + 1
      };

      addClaimedEntriesToDashboard(
        claimedEntries
      );

      dailyClaimInFlight = false;
      renderDailyClaimState();

      setDailyStatus(
        `${fmt(claimedEntries)} free entries added. Your timer has restarted.`,
        "is-success"
      );

      setTimeout(() => {
        if (
          dailyClaimState &&
          !dailyClaimState.eligible
        ) {
          startDailyCountdown();
        }
      }, 1800);

      if (isDailyUpsellEnabled()) {
        setTimeout(
          openDailyUpsellModal,
          350
        );
      }

    } catch (error) {
      console.error(
        "[UC DAILY ENTRIES] claim failed:",
        error
      );

      dailyClaimInFlight = false;
      renderDailyClaimState();

      setDailyStatus(
        error?.message ||
          "Unable to claim your daily entries.",
        "is-error"
      );
    }
  }

  /* =====================================================
     DAILY SPIN
  ===================================================== */

  function getDailySpinElements() {
    return {
      card: document.getElementById("ucDailySpinCard"),
      wheel: document.getElementById("ucDailySpinWheel"),
      button: document.getElementById("ucDailySpinButton"),
      status: document.getElementById("ucDailySpinStatus"),
      result: document.getElementById("ucDailySpinResult"),
      history: document.getElementById("ucDailySpinHistory"),
      historyList: document.getElementById("ucDailySpinHistoryList")
    };
  }

  function setDailySpinStatus(message, className = "") {
    const { status } = getDailySpinElements();
    if (!status) return;

    status.textContent = String(message || "");
    status.classList.remove("is-ready", "is-success", "is-error");
    if (className) status.classList.add(className);
  }

  function clearDailySpinCountdown() {
    if (dailySpinCountdownTimer) {
      clearInterval(dailySpinCountdownTimer);
      dailySpinCountdownTimer = null;
    }
  }

  function updateDailySpinCountdown() {
    if (
      !dailySpinState ||
      dailySpinState.eligible ||
      dailySpinState.promo_active === false
    ) {
      return;
    }

    const nextSpinAt = Number(dailySpinState.next_spin_at || 0);
    const remaining = Math.max(0, nextSpinAt - Date.now());

    if (remaining <= 0) {
      clearDailySpinCountdown();
      dailySpinState = {
        ...dailySpinState,
        eligible: true,
        milliseconds_remaining: 0
      };
      renderDailySpinState();
      return;
    }

    setDailySpinStatus(
      `Next spin available in ${formatCountdown(remaining)}`,
      "is-success"
    );
  }

  function startDailySpinCountdown() {
    clearDailySpinCountdown();
    updateDailySpinCountdown();

    if (!dailySpinState || dailySpinState.eligible) return;

    dailySpinCountdownTimer = setInterval(
      updateDailySpinCountdown,
      1000
    );
  }

  function updateDailySpinBonus() {
    const panel = document.getElementById("ucDailySpinBonus");
    if (!panel) return;

    const enabled = dailySpinState?.bonus_enabled === true;
    const candidates = Array.isArray(dailySpinHistory) ? dailySpinHistory : [];
    const reward = candidates.find(item =>
      String(item.discount_code || "").toUpperCase().startsWith("UCSPIN-") &&
      Number(item.bonus_entries || 0) > 0 &&
      !Number(item.redeemed_at || 0) &&
      Number(item.bonus_end || 0) > Date.now()
    );
    if (!enabled || !reward || dailySpinState?.promo_active === false) {
      panel.hidden = true;
      if (dailySpinBonusTimer) {
        clearInterval(dailySpinBonusTimer);
        dailySpinBonusTimer = null;
      }
      return;
    }
    panel.hidden = false;
    document.getElementById("ucDailySpinBonusEntries").textContent =
      `+${fmt(reward.bonus_entries)} BONUS ENTRIES`;
    document.getElementById("ucDailySpinBonusCode").textContent =
      String(reward.discount_code || "");
    const remaining = Math.max(0, Number(reward.bonus_end) - Date.now());
    document.getElementById("ucDailySpinBonusCountdown").textContent =
      formatCountdown(remaining);
    const totalMs = Math.max(1, Number(dailySpinState.bonus_hours || 6) * 3600000);
    document.getElementById("ucDailySpinBonusFill").style.width =
      `${Math.min(100, remaining / totalMs * 100)}%`;
    if (remaining <= 0) panel.hidden = true;
  }

  let dailySpinBonusRefreshInFlight = false;
  let dailySpinBonusLastRefreshAt = 0;

  async function refreshDailySpinBonusRedemption() {
    if (dailySpinBonusRefreshInFlight || !dailySpinState?.bonus_enabled) return;
    dailySpinBonusRefreshInFlight = true;
    try {
      const res = await fetch("/apps/referrals?action=daily-spin-status", {
        method: "GET",
        credentials: "same-origin",
        cache: "no-store",
        headers: { Accept: "application/json" }
      });
      const data = await res.json().catch(() => null);
      if (!res.ok || data?.success !== true || !data?.daily_spin) return;
      dailySpinState.bonus_enabled = data.daily_spin.bonus_enabled === true;
      dailySpinHistory = Array.isArray(data.daily_spin.history)
        ? data.daily_spin.history
        : dailySpinHistory;
      updateDailySpinBonus();
    } catch (error) {
      console.warn("[UC DAILY SPIN] bonus redemption refresh failed", error);
    } finally {
      dailySpinBonusRefreshInFlight = false;
    }
  }

  function startDailySpinBonusCountdown() {
    if (dailySpinBonusTimer) clearInterval(dailySpinBonusTimer);
    updateDailySpinBonus();
    if (!document.getElementById("ucDailySpinBonus")?.hidden) {
      dailySpinBonusLastRefreshAt = Date.now();
      dailySpinBonusTimer = setInterval(() => {
        updateDailySpinBonus();
        if (Date.now() - dailySpinBonusLastRefreshAt >= 20000) {
          dailySpinBonusLastRefreshAt = Date.now();
          refreshDailySpinBonusRedemption();
        }
      }, 1000);
    }
  }

  function getDailySpinColors(count) {
    const palette = [
      "#ff1493",
      "#00bfc9",
      "#e7a800",
      "#7d38ff",
      "#252c2e",
      "#ff6a00",
      "#00a86b",
      "#d62976"
    ];

    return Array.from(
      { length: count },
      (_, index) => palette[index % palette.length]
    );
  }

  function renderDailySpinWheel(prizes) {
    const { wheel } = getDailySpinElements();
    if (!wheel || !Array.isArray(prizes) || !prizes.length) return;

    const count = prizes.length;
    const segmentDegrees = 360 / count;
    const colors = getDailySpinColors(count);

    const gradientParts = prizes.map((_, index) => {
      const start = index * segmentDegrees;
      const end = (index + 1) * segmentDegrees;
      return `${colors[index]} ${start}deg ${end}deg`;
    });

    wheel.style.background = `conic-gradient(${gradientParts.join(",")})`;

    wheel.innerHTML = prizes.map((prize, index) => {
      const centerAngle = (index + 0.5) * segmentDegrees;
      const radians = (centerAngle - 90) * Math.PI / 180;
      const radius = 35;
      const x = 50 + Math.cos(radians) * radius;
      const y = 50 + Math.sin(radians) * radius;

      return `
        <div
          class="uc-daily-spin-wheel__label"
          data-spin-prize-id="${Number(prize.id)}"
          style="left:${x}%;top:${y}%;--uc-label-rotation:${centerAngle}deg;"
        >
          ${escapeHtml(prize.name)}
        </div>
      `;
    }).join("");
  }

  function formatSpinRewardDate(timestamp) {
    const value = Number(timestamp || 0);

    if (!Number.isFinite(value) || value <= 0) {
      return "";
    }

    return new Intl.DateTimeFormat(
      "en-US",
      {
        month: "short",
        day: "numeric",
        year: "numeric"
      }
    ).format(new Date(value));
  }

  function getSpinRewardExpiryText(expiresAt) {
    const value = Number(expiresAt || 0);

    if (!Number.isFinite(value) || value <= 0) {
      return "";
    }

    const remainingMs = value - Date.now();

    if (remainingMs <= 0) {
      return "Expired";
    }

    const daysRemaining = Math.max(
      1,
      Math.ceil(
        remainingMs /
        (
          24 *
          60 *
          60 *
          1000
        )
      )
    );

    return (
      `Expires in ${daysRemaining} ` +
      `${daysRemaining === 1 ? "day" : "days"}`
    );
  }

  async function copyDailySpinCode(code, button) {
    const value = String(code || "").trim();

    if (!value) return;

    try {
      await navigator.clipboard.writeText(value);

      if (button) {
        const originalText = button.textContent;

        button.textContent = "Copied";

        setTimeout(() => {
          button.textContent = originalText;
        }, 1400);
      }
    } catch (error) {
      console.error(
        "[UC DAILY SPIN] copy failed:",
        error
      );

      window.prompt(
        "Copy your discount code:",
        value
      );
    }
  }

  function showDailySpinReward(
    reward,
    {
      recent = false
    } = {}
  ) {
    const { result } = getDailySpinElements();

    if (!result || !reward) return;

    const prizeType =
      String(reward.prize_type || "");

    const prizeName =
      String(
        reward.prize_name ||
        reward.name ||
        ""
      );

    const discountCode =
      String(
        reward.discount_code || ""
      ).trim();

    const expiresAt =
      Number(
        reward.discount_expires_at ||
        0
      );

    const awardedAt =
      Number(
        reward.awarded_at ||
        0
      );

    let heading =
      recent
        ? "Your Recent Reward"
        : "You Won";

    if (
      !recent &&
      prizeType === "none"
    ) {
      heading =
        "Better Luck Tomorrow";
    }

    const expiryText =
      getSpinRewardExpiryText(
        expiresAt
      );

    const awardedDate =
      formatSpinRewardDate(
        awardedAt
      );

    const codeHtml =
      discountCode
        ? `
            <span class="uc-daily-spin-result__code">
              ${escapeHtml(discountCode)}
            </span>

            <button
              type="button"
              class="uc-daily-spin-copy-button"
              data-daily-spin-copy
              data-code="${escapeHtml(discountCode)}"
            >
              Copy Code
            </button>
          `
        : "";

    const metaParts = [];

    if (expiryText) {
      metaParts.push(
        escapeHtml(expiryText)
      );
    }

    if (awardedDate) {
      metaParts.push(
        `Awarded ${escapeHtml(awardedDate)}`
      );
    }

    const metaHtml =
      metaParts.length
        ? `
            <span class="uc-daily-spin-result__meta">
              ${metaParts.join(" • ")}
            </span>
          `
        : "";

    result.innerHTML = `
      ${escapeHtml(heading)}

      <span class="uc-daily-spin-result__prize">
        ${escapeHtml(prizeName)}
      </span>

      ${codeHtml}
      ${metaHtml}
    `;

    result.hidden = false;
  }

  function getSpinHistoryValueLabel(item) {
    const prizeType = String(item?.prize_type || "");
    const prizeValue = Number(item?.prize_value || 0);

    if (prizeType === "entries") {
      return `+${fmt(prizeValue)} Entries`;
    }

    if (prizeType === "discount_percent") {
      return `${prizeValue}% Off`;
    }

    if (prizeType === "discount_fixed") {
      return `$${prizeValue.toFixed(2)} Off`;
    }

    if (prizeType === "none") {
      return "No Prize";
    }

    return "";
  }

  function renderDailySpinHistory() {
    const { history, historyList } = getDailySpinElements();

    if (!history || !historyList) return;

    const items = Array.isArray(dailySpinHistory)
      ? dailySpinHistory
      : [];

    if (!items.length) {
      history.hidden = true;
      historyList.innerHTML = "";
      return;
    }

    historyList.innerHTML = items.map((item) => {
      const prizeName = String(item.prize_name || "");
      const valueLabel = getSpinHistoryValueLabel(item);
      const discountCode = String(item.discount_code || "").trim();

      const awardedAt = Number(
        item.awarded_at ||
        item.spun_at ||
        0
      );

      const expiresAt = Number(
        item.discount_expires_at ||
        0
      );

      const awardedDate = formatSpinRewardDate(awardedAt);
      const expiryText = discountCode
        ? getSpinRewardExpiryText(expiresAt)
        : "";

      const metaParts = [];

      if (awardedDate) {
        metaParts.push(`Awarded ${escapeHtml(awardedDate)}`);
      }

      if (expiryText) {
        metaParts.push(escapeHtml(expiryText));
      }

      const codeHtml = discountCode
        ? `
            <div class="uc-daily-spin-history__item-code">
              ${escapeHtml(discountCode)}
            </div>
          `
        : "";

      const copyHtml =
        discountCode &&
        expiryText !== "Expired"
          ? `
              <button
                type="button"
                class="uc-daily-spin-copy-button"
                data-daily-spin-copy
                data-code="${escapeHtml(discountCode)}"
              >
                Copy Code
              </button>
            `
          : "";

      return `
        <div class="uc-daily-spin-history__item">
          <div class="uc-daily-spin-history__item-main">
            <div class="uc-daily-spin-history__item-name">
              ${escapeHtml(prizeName)}
            </div>

            ${codeHtml}

            ${
              metaParts.length
                ? `
                    <div class="uc-daily-spin-history__item-meta">
                      ${metaParts.join(" • ")}
                    </div>
                  `
                : ""
            }
          </div>

          <div class="uc-daily-spin-history__item-actions">
            ${
              valueLabel
                ? `
                    <div class="uc-daily-spin-history__item-value">
                      ${escapeHtml(valueLabel)}
                    </div>
                  `
                : ""
            }

            ${copyHtml}
          </div>
        </div>
      `;
    }).join("");

    history.hidden = false;
  }

  function hideDailySpinResult() {
    const { result } = getDailySpinElements();
    if (!result) return;
    result.hidden = true;
    result.innerHTML = "";
  }

  function showDailySpinResult(prize) {
    showDailySpinReward(
      prize,
      {
        recent: false
      }
    );
  }

  function renderDailySpinState() {
    const { card, button } = getDailySpinElements();
    if (!card || !button || !dailySpinState) return;

    if (dailySpinState.enabled !== true) {
      clearDailySpinCountdown();
      card.hidden = true;
      return;
    }

    card.hidden = false;

    if (dailySpinState.promo_active === false) {
      clearDailySpinCountdown();

      button.disabled = true;

      if (
        dailySpinState.promo_state ===
        "not_started"
      ) {
        button.textContent =
          "Promotion Not Started";

        setDailySpinStatus(
          "Daily Spin will unlock when the giveaway begins."
        );
      } else {
        button.textContent =
          "Promotion Ended";

        setDailySpinStatus(
          "Daily Spin is unavailable because this giveaway has ended."
        );
      }

      return;
    }

    if (dailySpinInFlight) {
      clearDailySpinCountdown();
      button.disabled = true;
      button.textContent = "Spinning...";
      setDailySpinStatus("Your prize is being selected...");
      return;
    }

    if (dailySpinState.eligible) {
      clearDailySpinCountdown();
      button.disabled = false;
      button.textContent = "Spin Now";
      setDailySpinStatus("Your Daily Spin is ready.", "is-ready");
      return;
    }

    button.disabled = true;
    button.textContent = "Spin Used";
    startDailySpinCountdown();
  }

  async function loadDailySpinStatus() {
    if (!isDailySpinEnabled()) return;

    const { card, button } = getDailySpinElements();

    if (button) {
      button.disabled = true;
      button.textContent = "Checking...";
    }

    if (!IS_LOCALHOST && !window.UC_IS_LOGGED_IN) {
      if (card) card.hidden = true;
      return;
    }

    if (!IS_LOCALHOST && window.UC_IS_CHARGEBACK) {
      if (card) card.hidden = true;
      return;
    }

    if (IS_LOCALHOST) {
      if (card) card.hidden = true;
      return;
    }

    try {
      const res = await fetch(
        "/apps/referrals?action=daily-spin-status",
        {
          method: "GET",
          credentials: "same-origin",
          headers: { Accept: "application/json" }
        }
      );

      const data = await res.json().catch(() => null);

      if (!res.ok || data?.success !== true || !data?.daily_spin) {
        throw new Error(data?.error || "Unable to load Daily Spin status.");
      }

      const prizes = Array.isArray(data.daily_spin.prizes)
        ? data.daily_spin.prizes
        : [];

      dailySpinState = {
        ...data.daily_spin,
        enabled: data.daily_spin.enabled === true,
        eligible: data.daily_spin.eligible === true,
        promo_active:
          data.daily_spin.promo_active === true,
        promo_state:
          String(
            data.daily_spin.promo_state ||
            ""
          ),
        promo_start:
          data.daily_spin.promo_start ||
          null,
        promo_end:
          data.daily_spin.promo_end ||
          null,
        next_spin_at: data.daily_spin.next_spin_at
          ? Number(data.daily_spin.next_spin_at)
          : null,
        total_spins: Math.max(0, Number(data.daily_spin.total_spins || 0)),
        bonus_enabled: data.daily_spin.bonus_enabled === true,
        bonus_hours: Number(data.daily_spin.bonus_hours || 6),
        prizes
      };

      if (!dailySpinState.enabled || !prizes.length) {
        clearDailySpinCountdown();
        if (card) card.hidden = true;
        return;
      }

      renderDailySpinWheel(prizes);
      renderDailySpinState();

      dailySpinHistory = Array.isArray(
        data.daily_spin.history
      )
        ? data.daily_spin.history
        : [];

      renderDailySpinHistory();
      startDailySpinBonusCountdown();

      /*
        The result box is only for the prize
        won during the current page session.
        History persists separately below it.
      */
      hideDailySpinResult();
    } catch (error) {
      console.error("[UC DAILY SPIN] status failed:", error);
      clearDailySpinCountdown();
      if (card) card.hidden = true;
    }
  }

  function animateDailySpinToPrize(prizeId) {
    return new Promise((resolve) => {
      const { wheel } = getDailySpinElements();
      const prizes = Array.isArray(dailySpinState?.prizes)
        ? dailySpinState.prizes
        : [];

      if (!wheel || !prizes.length) {
        resolve();
        return;
      }

      const winnerIndex = prizes.findIndex(
        prize => Number(prize.id) === Number(prizeId)
      );

      if (winnerIndex < 0) {
        resolve();
        return;
      }

      const segmentDegrees = 360 / prizes.length;
      const winnerCenter = (winnerIndex + 0.5) * segmentDegrees;
      const normalizedCurrent = ((dailySpinRotation % 360) + 360) % 360;
      const targetNormalized = (360 - winnerCenter) % 360;
      const correction = (targetNormalized - normalizedCurrent + 360) % 360;

      dailySpinRotation += (6 * 360) + correction;
      wheel.style.transform = `rotate(${dailySpinRotation}deg)`;

      window.setTimeout(resolve, 5650);
    });
  }

  async function spinDailyWheel() {
    if (dailySpinInFlight || !dailySpinState?.eligible) return;

    dailySpinInFlight = true;
    hideDailySpinResult();
    renderDailySpinState();

    try {
      const res = await fetch(
        "/apps/referrals?action=daily-spin",
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({})
        }
      );

      const data = await res.json().catch(() => null);

      if (res.status === 429 && data?.code === "SPIN_COOLDOWN") {
        dailySpinInFlight = false;
        dailySpinState = {
          ...dailySpinState,
          eligible: false,
          next_spin_at: data.next_spin_at
            ? Number(data.next_spin_at)
            : dailySpinState?.next_spin_at || null,
          milliseconds_remaining: Math.max(
            0,
            Number(data.milliseconds_remaining || 0)
          )
        };
        renderDailySpinState();
        return;
      }

      if (res.status === 403 && data?.code === "DAILY_SPIN_DISABLED") {
        dailySpinInFlight = false;
        dailySpinState = {
          ...dailySpinState,
          enabled: false,
          eligible: false
        };
        renderDailySpinState();
        return;
      }

      if (res.status === 403 && data?.code === "PROMO_CLOSED") {
        dailySpinInFlight = false;

        dailySpinState = {
          ...dailySpinState,
          eligible: false,
          promo_active: false,
          promo_state:
            String(
              data.promo_state ||
              "ended"
            ),
          promo_start:
            data.promo_start ||
            dailySpinState?.promo_start ||
            null,
          promo_end:
            data.promo_end ||
            dailySpinState?.promo_end ||
            null
        };

        renderDailySpinState();
        return;
      }

      if (!res.ok || data?.success !== true || !data?.prize) {
        dailySpinInFlight = false;
        await loadDailySpinStatus();
        setDailySpinStatus(
          data?.error || "Unable to complete your Daily Spin.",
          "is-error"
        );
        return;
      }

      const prize = data.prize;

      dailySpinState = {
        ...dailySpinState,
        eligible: false,
        last_spin_at: Number(data.spun_at || Date.now()),
        next_spin_at: Number(data.next_spin_at || 0),
        milliseconds_remaining: Math.max(
          0,
          Number(data.next_spin_at || 0) - Date.now()
        ),
        total_spins: Math.max(
          0,
          Number(data.total_spins || dailySpinState?.total_spins || 0)
        )
      };

      await animateDailySpinToPrize(prize.id);

      if (String(prize.prize_type || "") === "entries") {
        addClaimedEntriesToDashboard(Number(prize.value || 0));
      }

      const awardedAt = Date.now();

      const historyItem = {
        claim_id: Number(data.claim_id || 0),
        prize_id: Number(prize.id || 0),
        prize_name: String(prize.name || ""),
        prize_type: String(prize.prize_type || ""),
        prize_value: Number(prize.value || 0),
        discount_code: prize.discount_code || null,
        spun_at: Number(data.spun_at || awardedAt),
        awarded_at: awardedAt,
        discount_expires_at: prize.discount_expires_at
          ? Number(prize.discount_expires_at)
          : null,
        bonus_end: Number(prize.bonus_end || 0),
        bonus_entries: Number(prize.bonus_entries || 0),
        redeemed_at: null
      };

      dailySpinHistory = [
        historyItem,
        ...dailySpinHistory.filter(
          item =>
            Number(item.claim_id) !==
            Number(historyItem.claim_id)
        )
      ].slice(0, 20);

      renderDailySpinHistory();
      startDailySpinBonusCountdown();

      showDailySpinResult({
        ...prize,
        awarded_at: awardedAt
      });

      dailySpinInFlight = false;
      renderDailySpinState();
      setDailySpinStatus("Your spin is complete.", "is-success");

      setTimeout(() => {
        if (
          dailySpinState &&
          !dailySpinState.eligible &&
          dailySpinState.promo_active !== false
        ) {
          startDailySpinCountdown();
        }
      }, 1800);
    } catch (error) {
      console.error("[UC DAILY SPIN] spin failed:", error);
      dailySpinInFlight = false;
      await loadDailySpinStatus();
      setDailySpinStatus(
        error?.message || "Unable to complete your Daily Spin.",
        "is-error"
      );
    }
  }

  function initDailySpin() {
    if (!isDailySpinEnabled()) return;

    const { button } = getDailySpinElements();

    if (button) {
      button.addEventListener("click", spinDailyWheel);
    }

    const {
      result,
      historyList
    } = getDailySpinElements();

    const handleCopyClick = (event) => {
      const copyButton =
        event.target.closest(
          "[data-daily-spin-copy]"
        );

      if (!copyButton) {
        return;
      }

      copyDailySpinCode(
        copyButton.dataset.code,
        copyButton
      );
    };

    if (result) {
      result.addEventListener(
        "click",
        handleCopyClick
      );
    }

    if (historyList) {
      historyList.addEventListener(
        "click",
        handleCopyClick
      );
    }

    loadDailySpinStatus();
  }


  function openDailyUpsellModal() {
    const modal =
      document.getElementById(
        "ucDailyUpsellModal"
      );

    if (!modal) {
      return;
    }

    lastFocusedElement =
      document.activeElement;

    modal.hidden = false;
    modal.setAttribute(
      "aria-hidden",
      "false"
    );

    document.body.style.overflow =
      "hidden";

    const closeButton =
      modal.querySelector(
        "[data-daily-upsell-close]"
      );

    if (closeButton) {
      setTimeout(
        () => closeButton.focus(),
        0
      );
    }
  }

  function closeDailyUpsellModal() {
    const modal =
      document.getElementById(
        "ucDailyUpsellModal"
      );

    if (!modal) {
      return;
    }

    modal.hidden = true;
    modal.setAttribute(
      "aria-hidden",
      "true"
    );

    document.body.style.overflow =
      "";

    if (
      lastFocusedElement &&
      typeof lastFocusedElement.focus ===
        "function"
    ) {
      lastFocusedElement.focus();
    }

    lastFocusedElement = null;
  }

  async function buyDailyUpsell() {
    const button =
      document.getElementById(
        "ucDailyUpsellBuy"
      );

    if (
      !button ||
      button.disabled
    ) {
      return;
    }

    const variantId = Number(
      button.dataset.variantId || 0
    );

    if (
      !Number.isInteger(variantId) ||
      variantId <= 0
    ) {
      return;
    }

    const originalText =
      button.textContent;

    button.disabled = true;
    button.textContent =
      "Adding...";

    try {
      const res = await fetch(
        "/cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
            Accept:
              "application/json"
          },
          body:
            JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                  properties: {
                    _uc_daily_claim_upsell:
                      "true"
                  }
                }
              ]
            })
        }
      );

      const data =
        await res
          .json()
          .catch(() => null);

      if (!res.ok) {
        throw new Error(
          data?.description ||
          data?.message ||
          "Unable to add this offer."
        );
      }

      button.textContent =
        "Opening Checkout...";

      window.location.href =
        "/checkout";

    } catch (error) {
      console.error(
        "[UC DAILY UPSELL] add failed:",
        error
      );

      button.disabled = false;
      button.textContent =
        originalText;

      window.alert(
        error?.message ||
          "Unable to add this offer. Please try again."
      );
    }
  }

  function initDailyEntries() {
    if (!isDailyEnabled()) {
      return;
    }

    const { button } =
      getDailyElements();

    if (button) {
      button.addEventListener(
        "click",
        claimDailyEntries
      );
    }

    document
      .querySelectorAll(
        "[data-daily-upsell-close]"
      )
      .forEach((element) => {
        element.addEventListener(
          "click",
          closeDailyUpsellModal
        );
      });

    const upsellBuyButton =
      document.getElementById(
        "ucDailyUpsellBuy"
      );

    if (upsellBuyButton) {
      upsellBuyButton.addEventListener(
        "click",
        buyDailyUpsell
      );
    }

    const upsellEntryCount =
      document.querySelector(
        "[data-daily-upsell-entry-count]"
      );

    if (upsellEntryCount) {
      const rawValue =
        String(
          upsellEntryCount.textContent || ""
        )
          .replace(/,/g, "")
          .trim();

      const value = Number(rawValue);

      if (Number.isFinite(value)) {
        upsellEntryCount.textContent =
          fmt(value);
      }
    }

    document.addEventListener(
      "keydown",
      (event) => {
        if (
          event.key !== "Escape"
        ) {
          return;
        }

        const modal =
          document.getElementById(
            "ucDailyUpsellModal"
          );

        if (
          modal &&
          !modal.hidden
        ) {
          closeDailyUpsellModal();
        }
      }
    );

    loadDailyStatus();
  }

  async function loadEntries() {
    const turnstileWrap =
      document.querySelector(
        ".uc-turnstile-wrap"
      );

    if (
      IS_LOCALHOST &&
      turnstileWrap
    ) {
      turnstileWrap.style.display =
        "none";
    }

    if (
      !IS_LOCALHOST &&
      window.UC_IS_CHARGEBACK
    ) {
      return;
    }

    if (
      !IS_LOCALHOST &&
      window.UC_ADMIN_ONLY_MODE &&
      !window.UC_IS_ADMIN
    ) {
      showError(
        "Under Construction",
        "This page is currently unavailable. Please check back later."
      );

      return;
    }

    if (
      !IS_LOCALHOST &&
      !window.UC_IS_LOGGED_IN
    ) {
      showError(
        "Sign In Required",
        "Please sign in to view your entries."
      );

      return;
    }

    try {
      let turnstileToken = "";

      if (!IS_LOCALHOST) {
        turnstileToken =
          await waitForTurnstileToken();

        if (!turnstileToken) {
          showError(
            "Security Check Required",
            "Complete the security check and try again."
          );

          return;
        }
      }

      const requestBody = {
        turnstileToken
      };

      if (IS_LOCALHOST) {
        requestBody.testEmail =
          LOCAL_TEST_EMAIL;

        console.log(
          "[UC LOCAL TEST MODE]",
          LOCAL_TEST_EMAIL
        );
      }

      const res = await fetch(
        "/apps/my-entries",
        {
          method: "POST",

          headers: {
            "Content-Type":
              "application/json",

            Accept:
              "application/json"
          },

          body:
            JSON.stringify(
              requestBody
            )
        }
      );

      const raw =
        await res.text();

      let data = {};

      try {
        data =
          JSON.parse(raw);
      } catch {
        data = {
          ok: false,
          code:
            "NON_JSON_RESPONSE",
          message:
            raw ||
            "Non-JSON response"
        };
      }

      console.log(
        "[MY ENTRIES] status:",
        res.status
      );

      console.log(
        "[MY ENTRIES] data:",
        data
      );

      if (
        !res.ok ||
        !data.ok
      ) {
        showError(
          "Unable To Load Entries",
          data.message ||
            "We couldn't load your entries.",
          data.code
            ? `Code: ${data.code}`
            : ""
        );

        return;
      }

      showEntries(data);

    } catch (err) {
      console.error(
        "[UC MY ENTRIES] load failed:",
        err
      );

      showError(
        "Unable To Load Entries",
        "Something went wrong while loading your entries."
      );
    }
  }

  function formatDownloadSize(bytes) {
  const value =
    Number(bytes || 0);

  if (value <= 0) {
    return "";
  }

  if (value < 1024) {
    return `${value} B`;
  }

  if (value < 1024 * 1024) {
    return `${(
      value / 1024
    ).toFixed(1)} KB`;
  }

  return `${(
    value /
    (1024 * 1024)
  ).toFixed(1)} MB`;
}

async function loadDownloads() {
  const list =
    document.getElementById(
      "ucDownloadsList"
    );

  const downloadAllButton =
    document.getElementById(
      "ucDownloadAllButton"
    );

  if (!list) {
    return;
  }

  if (downloadAllButton) {
    downloadAllButton.hidden =
      true;
  }

  try {
    const res =
      await fetch(
        "/apps/my-entries/downloads",
        {
          method: "POST",
          credentials:
            "same-origin",
          headers: {
            Accept:
              "application/json",
            "Content-Type":
              "application/json"
          },
          body:
            JSON.stringify({})
        }
      );

    const data =
      await res
        .json()
        .catch(() => null);

    if (
      !res.ok ||
      data?.ok !== true
    ) {
      throw new Error(
        "Unable to load downloads."
      );
    }

    const downloads =
      Array.isArray(
        data.downloads
      )
        ? data.downloads
        : [];

    if (!downloads.length) {
      list.innerHTML = `
        <div class="uc-downloads-empty">
          You do not have any digital downloads yet.
        </div>
      `;

      return;
    }

    if (downloadAllButton) {
      downloadAllButton.href =
        "/apps/my-entries/download-all";

      downloadAllButton.hidden =
        false;
    }

    list.innerHTML =
      downloads
        .map(file => {
          const fileId =
            Number(
              file.file_id || 0
            );

          const name =
            escapeHtml(
              file.display_name ||
              file.filename ||
              "Download"
            );

          const productTitle =
            escapeHtml(
              file.product_title || ""
            );

          const orderName =
            escapeHtml(
              file.order_name ||
              ""
            );

          const size =
            formatDownloadSize(
              file.file_size
            );

          const meta = [
            orderName
              ? `Order ${orderName}`
              : "",
            size
          ]
            .filter(Boolean)
            .join(" • ");

          return `
            <div class="uc-download-item">
              <div>
                ${
                  productTitle
                    ? `
                      <div class="uc-download-item__meta">
                        ${productTitle}
                      </div>
                    `
                    : ""
                }

                <div class="uc-download-item__name">
                  ${name}
                </div>

                ${
                  meta
                    ? `
                      <div class="uc-download-item__meta">
                        ${escapeHtml(meta)}
                      </div>
                    `
                    : ""
                }
              </div>

              <a
                class="uc-download-item__button"
                href="/apps/my-entries/download-file?file_id=${fileId}"
              >
                Download
              </a>
            </div>
          `;
        })
        .join("");

  } catch (error) {
    console.error(
      "[UC DOWNLOADS]",
      error
    );

    list.innerHTML = `
      <div class="uc-downloads-error">
        Unable to load your downloads right now.
      </div>
    `;
  }
}

  function init() {
    loadEntries();
    loadDownloads();
    initDailyEntries();
    initDailySpin();
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      {
        once: true
      }
    );
  } else {
    init();
  }
})();
